export default "__VITE_ASSET__gpKcAsTf__"